export default {
  path: "/",
  name: "Inventory",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      component: () => import("@/views/Inventory/goods_receipt.vue"),
    },
    {
      path: "/inventory/goodsreceipt",
      name: "Goods Receipt",
      component: {
        render(c) {
          return c("router-view");
        },
      },

      children: [
        {
          path: "",
          component: () => import("@/views/Inventory/goodsReceipt.vue"),
        },
        {
          path: "create_goods_receipt",
          name: "Create Goods Receipt",
          component: () => import("@/views/Inventory/create_goods_receipt.vue"),
        },
        {
          path: "edit_goods/:id",
          name: "Edit Goods Receipt",
          component: () => import("@/views/Inventory/edit_goods.vue"),
        },
        {
          path: "view_goods/:id",
          name: "View Goods Receipt",
          component: () => import("@/views/Inventory/view_goods.vue"),
        },
      ]
    },
    {
      path: "/inventory/stockupload",
      name: "Stock Upload",
      component: {
        render(c) {
          return c("router-view");
        },
      },

      children: [
        {
          path: "",
          component: () => import("@/views/Inventory/stockUpload.vue"),
        },
        {
          path: "load_devices",
          name: "Add Stock Upload",
          component: () => import("@/views/Inventory/load_devices.vue"),
        },
      ]
    },
    {
      path: "/inventory/stocktransfer",
      name: "Stock Transfer",
      component: {
        render(c) {
          return c("router-view");
        },
      },

      children: [
        {
          path: "",
          component: () => import("@/views/Inventory/stockTransfer.vue"),
        },
        {
          path: "create_item_sale",
          name: "Create Item Sale",
          component: () => import("@/views/Inventory/create_item_sale.vue"),
        },
        {
          path: "editItemsale/:id",
          name: "Edit Item Sale",
          component: () => import("@/views/Inventory/editItemsale.vue"),
        },
        {
          path: "create_mrn",
          name: "Create MRN",
          component: () => import("@/views/Inventory/create_mrn.vue"),
        },
        {
          path: "editMrn/:id",
          name: "Edit MRN",
          component: () => import("@/views/Inventory/editMrn.vue"),
        },
        {
          path: "create_grv",
          name: "Create GRV",
          component: () => import("@/views/Inventory/create_grv.vue"),
        },
        {
          path: "editGrv/:id",
          name: "Edit GRV",
          component: () => import("@/views/Inventory/editGrv.vue"),
        },
        {
          path: "move_item_mrn_grv/:id/:item",
          name: "Move Item Sale MRN GRV",
          component: () => import("@/views/Inventory/move_item_mrn_grv.vue"),
        },
        {
          path: "view_grv/:id",
          name: "View GRN",
          component: () => import("@/views/Inventory/StockTransfer/view_grv.vue"),
        },

        {
          path: "view_devices",
          name: "View Devices",
          component: () => import("@/views/Inventory/view_devices.vue"),
        },
        {
          path: "viewitemDetailsSingle/:id",
          name: "View Item Details",
          component: () => import("@/views/Inventory/viewitemDetailsSingle.vue"),
        },
        {
          path: "stock_transfer",
          name: "Stock Transfer",
          component: () =>
            import("@/views/Inventory/StockTransfer/stock_transfer.vue"),
        },
        {
          path: "view_stock/:id/:type",
          name: "View Stock Transfer",
          component: () => import("@/views/Inventory/StockTransfer/view_stock.vue"),
        },
        {
          path: "view_grv/:id/:type",
          name: "View GRV",
          component: () => import("@/views/Inventory/StockTransfer/view_grv.vue"),
        },
        {
          path: "view_mrn/:id/:type",
          name: "View MRN",
          component: () => import("@/views/Inventory/StockTransfer/view_mrn.vue"),
        },
        {
          path: "moveMrn/:id",
          name: "Move MRN",
          component: () => import("@/views/Inventory/StockTransfer/moveMrn.vue"),
        },
        {
          path: "moveGrv/:id",
          name: "Move GRV",
          component: () => import("@/views/Inventory/StockTransfer/moveGrv.vue"),
        },
        {
          path: "moveSales/:id",
          name: "Move Sales",
          component: () => import("@/views/Inventory/StockTransfer/moveSales.vue"),
        },
        {
          path: "movecartoondata",
          name: "Move Cartoon Data",
          component: () =>
            import("@/views/Inventory/StockTransfer/movecartoondata.vue"),
        },
        {
          path: "createmrn",
          name: "Create MRN",
          component: () => import("@/views/Inventory/StockTransfer/createmrn.vue"),
        },
      ]
    },
    {
      path: "/",
      name: "No Generator",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          // component: () => import("@/views/setup/Plan/Index"),
        },
        {
          path: "/inventory/voucher-pins",
          name: "Voucher Pins",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/Inventory/Vendors/VoucherPins/vouchers.vue"),
            },
            {
              path: "createvoucherpin",
              name: "Create Voucher Pin",
              component: () =>
                import("@/views/Inventory/Vendors/VoucherPins/CreateVoucher.vue"),
            },
            {
              path: "voucherpinlist/:id",
              name: "Voucher Pins",
              component: () =>
                import("@/views/Inventory/Vendors/VoucherPins/voucherPins.vue"),
            },
          ],
        },
        {
          path: "/inventory/vendor-management",
          name: "Vendor Management",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/Inventory/Vendors/Vendor_Management/view_vendor_mgmt.vue"
                ),
            },
            {
              path: "edit_vendor/:id",
              name: "Edit Vendor Management",
              component: () =>
                import(
                  "@/views/Inventory/Vendors/Vendor_Management/edit_vendor.vue"
                ),
            },
            {
              path: "view_vendor/:id",
              name: "View Vendor Management",
              component: () =>
                import(
                  "@/views/Inventory/Vendors/Vendor_Management/view_vendor.vue"
                ),
            },
            {
              path: "create_vendor_mgmt",
              name: "Create Vendor Management",
              component: () =>
                import(
                  "@/views/Inventory/Vendors/Vendor_Management/create_vendor_mgmt.vue"
                ),
            },
          ],
        },
        {
          path: "/inventory/ip-management",
          name: "IP Management",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/Inventory/Vendors/IpManagement/Index.vue"),
            },
          ],
        },
        {
          path: "/inventory/sim-numbers",
          name: "SIM Number",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/Inventory/Vendors/SimNumber/NumberList.vue"),
            },
            {
              path: "create-sim-numbers",
              name: "Create SIM Number",
              component: () =>
                import("@/views/Inventory/Vendors/SimNumber/CreateSimNumber.vue"),
            },
          ],
        },
      ]
    },


  ],
};
